import React, { useEffect, useState } from "react"
import defalutStyle from "../../styles/defaultPageStyle.module.css"
import { RegisterEntity } from "../../Objects/Register/RegisterEntity"
import { TitleChildrenPath, TitlePageResponsiveIconSmall } from "../Titles/Titles"
import { ButtonIcon } from "../Button/Button"
import { faCalendar, faClose, faRegistered, faWarning } from "@fortawesome/free-solid-svg-icons"
import GetSpace from "../../utils/space"
import { CardEmployeeRegister } from "../CardEmployeeRegister/CardEmployeeRegister"
import { employeeMemory } from "../../Objects/Memory/Memory"
import THEME from "../../configuration/Theme"
import { SIZE } from "../../configuration/Sizes"
import { useGetRegister } from "../../hooks/Register/useGetRegister"
import ModalPortal from "../Modal/ModalPortal"
import Animate, { AnimationTypes } from "../Animate/Animate"
import { CountElements } from "../CountElements/CountElements"
import { useTranslation } from "react-i18next"

interface RegisterProps {
  id: string | number
  typeEntity: string
  onClose: () => void
}

export const ViewRegister: React.FC<RegisterProps> = ({ id, typeEntity, onClose }) => {
  const { t } = useTranslation("viewRegister")

  const { handleGet } = useGetRegister()

  const [registers, setRegisters] = useState<RegisterEntity[]>()

  useEffect(() => {
    const fetchData = async () => {
      const registersTemp = await handleGet(() => {}, id, typeEntity)

      setRegisters(registersTemp.reverse())
    }

    fetchData()
  }, [])

  return (
    <ModalPortal>
      <div className={defalutStyle.overlay}>
        <Animate type={AnimationTypes.slideUpIn} duration="0.3s">
          <div className={defalutStyle.alert}>
            <TitleChildrenPath
              title={t("title_popup")}
              icon={faRegistered}
              iconColor={THEME.colors.iconBGColor}
              subtitleChildren={
                <ButtonIcon
                  sizeNumber={SIZE.buttonCloseIconSize}
                  bgColor={THEME.colors.buttonBGCloseColor}
                  iconColor={THEME.colors.buttonFGCloseColor}
                  icon={faClose}
                  onClick={onClose}
                  size="small"
                  descriptionKey="interactionDescriptions:components.viewRegister.viewRegister.button.onClose"
                />
              }
              children={
                <>
                  <div className={defalutStyle.divisionBar}></div>

                  {registers && registers.length == 0 && (
                    <TitlePageResponsiveIconSmall
                      boxShadow="none"
                      icon={faWarning}
                      subtitle={t("label_description_empty")}
                    />
                  )}

                  {registers && registers.length > 0 && (
                    <CountElements
                      boxShadow="none"
                      count={registers.length}
                      title={t("label_count_founded")}
                      animationTypes={AnimationTypes.slideUpIn}
                      animationDuration="2s"
                    />
                  )}

                  {registers?.map((e, index) => {
                    return (
                      <React.Fragment key={index}>
                        <GetSpace top={5} />

                        <CardEmployeeRegister
                          icon={faCalendar}
                          iconColor={THEME.colors.iconBGSecondaryColor}
                          title={e.description}
                          date={e.lastUpdate}
                          employee={employeeMemory.findByStringId(e.employeeEditeId)!}
                        />
                      </React.Fragment>
                    )
                  })}
                </>
              }
            />
          </div>
        </Animate>
      </div>
    </ModalPortal>
  )
}
